import { render, staticRenderFns } from "./TraxAccountUserCrudSearch.vue?vue&type=template&id=f43040aa"
import script from "./TraxAccountUserCrudSearch.vue?vue&type=script&lang=js"
export * from "./TraxAccountUserCrudSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports